import { motion } from "motion/react";

const sections = [
  {
    title: "1. Acceptance of These Terms",
    items: [
      "By using this website, you agree to these terms and any related policies referenced here.",
      "If you do not agree with the terms, you should not use the website or its services.",
      "We may update these terms when needed, and the updated version will apply from the time it is posted.",
    ],
  },
  {
    title: "2. Use of the Website",
    items: [
      "Use the website lawfully and in a way that does not harm the platform, its users, or its content.",
      "Do not attempt to bypass security controls, misuse forms, scrape content, or use automated tools without permission.",
      "Any account or transaction information you provide must be accurate, complete, and current.",
    ],
  },
  {
    title: "3. Intellectual Property",
    items: [
      "All site content, graphics, brand assets, and design elements are protected and remain our property or the property of our licensors.",
      "You may view the website for personal, non-commercial use only unless we give you written permission otherwise.",
      "You may not copy, republish, distribute, reverse engineer, or create derivative works from the website content without consent.",
    ],
  },
  {
    title: "4. Donations, Payments, and Campaigns",
    items: [
      "Payments may be processed by third-party gateways or payment partners.",
      "We are not responsible for issues caused by third-party payment systems beyond our control.",
      "You are responsible for complying with any legal or tax obligations related to your contribution.",
    ],
  },
  {
    title: "5. User Submissions and Conduct",
    items: [
      "If you send us content, you confirm that you have the right to share it and that it does not violate any law or third-party rights.",
      "You must not upload abusive, defamatory, obscene, threatening, fraudulent, or harmful material.",
      "We may remove content or restrict access if we believe the terms have been violated.",
    ],
  },
  {
    title: "6. Liability, Links, and Governing Law",
    items: [
      "The website is provided on an as-is basis and we do not guarantee uninterrupted availability or error-free operation.",
      "Links to external websites are provided for convenience only; we are not responsible for their content or policies.",
      "These terms are governed by the laws of India, and disputes are subject to the courts and procedures we specify in our official policy documents.",
    ],
  },
];

export function TermsOfUse() {
  return (
    <main className="bg-white text-foreground">
      <section className="relative overflow-hidden border-b border-border bg-gradient-to-br from-secondary/10 via-white to-primary/10 py-24">
        <div className="absolute inset-0 opacity-40 [background-image:radial-gradient(circle_at_top_right,_rgba(56,111,91,0.10),_transparent_32%),radial-gradient(circle_at_bottom_left,_rgba(178,97,66,0.12),_transparent_30%)]" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-sm uppercase tracking-[0.3em] text-primary mb-4">
              Terms of Use
            </p>
            <h1 className="text-5xl md:text-6xl mb-6 font-bold tracking-tight">
              Terms of Use and Disclaimer
            </h1>
            <p className="text-xl text-muted-foreground leading-relaxed max-w-3xl">
              These terms explain how the site may be used, what content is protected,
              and the limits that apply when you browse, submit information, or engage
              with our campaigns and services.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          {sections.map((section, index) => (
            <motion.section
              key={section.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="rounded-3xl border border-border bg-muted/20 p-8 shadow-sm"
            >
              <h2 className="text-3xl mb-5">{section.title}</h2>
              <ul className="space-y-4 text-lg text-muted-foreground leading-relaxed list-disc pl-6">
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </motion.section>
          ))}

          <motion.section
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="rounded-3xl border border-border bg-primary/5 p-8"
          >
            <h2 className="text-3xl mb-4">Contact and Review</h2>
            <div className="space-y-4 text-lg text-muted-foreground leading-relaxed">
              <p>
                If you have questions about these terms, please contact us at
                hello@immerse.foundation.
              </p>
              <p>
                Please review this page regularly because the terms may change as the
                website, campaigns, or legal obligations evolve.
              </p>
              <p className="text-sm uppercase tracking-[0.2em] text-primary">
                Last reviewed: 29 September 2023
              </p>
            </div>
          </motion.section>
        </div>
      </section>
    </main>
  );
}
